export default __webpack_public_path__ + "static/media/icon_mail_orange.defb6e9d.svg";